import { Component, Input } from '@angular/core';

@Component({
  selector: 'share-buttons',
  template: `
    <div class="share-buttons-wrapper">
      <a [href]="'https://www.facebook.com/sharer/sharer.php?u='+encodedUrl"
         target="_blank" class="share-btn share-facebook" title="Facebook">
        <i class="fa fa-facebook"></i>
      </a>
      <a [href]="'https://twitter.com/intent/tweet?url='+encodedUrl+'&text='+encodedTitle"
         target="_blank" class="share-btn share-twitter" title="Twitter">
        <i class="fa fa-twitter"></i>
      </a>
      <a [href]="'https://api.whatsapp.com/send?text='+encodedTitle+'%20'+encodedUrl"
         target="_blank" class="share-btn share-whatsapp" title="WhatsApp">
        <i class="fa fa-whatsapp"></i>
      </a>
      <a (click)="copyLink()" class="share-btn share-copy" title="Copy Link" style="cursor:pointer">
        <i class="fa fa-copy"></i>
      </a>
    </div>
  `,
  styles: [`
    .share-buttons-wrapper { display:flex; gap:8px; flex-wrap:wrap; }
    .share-btn { display:inline-flex; align-items:center; justify-content:center;
      width:36px; height:36px; border-radius:50%; color:white;
      text-decoration:none; font-size:14px; }
    .share-facebook { background:#3b5998; }
    .share-twitter { background:#1da1f2; }
    .share-whatsapp { background:#25d366; }
    .share-copy { background:#6c757d; }
  `]
})
export class ShareButtonsComponent {
  @Input() url: string = '';
  @Input() title: string = '';
  get encodedUrl() { return encodeURIComponent(this.url || window.location.href); }
  get encodedTitle() { return encodeURIComponent(this.title || document.title); }
  copyLink() {
    navigator.clipboard.writeText(this.url || window.location.href).catch(() => {});
  }
}
